
import { useEffect, useState } from 'react'
import SetSocialForm from '../social_form/SetSocialForm';
import SetThemeForm from '../theme_form/SetThemeForm';
import SetNavbarForm from '../navbar_form/SetNavbarForm';
import SetBusinessInfoForm from '../businessInfo_form/SetBusinessInfoForm';
import SetPersonalInfoForm from '../personalInfo_form/SetPersonalInfoForm';
import SetLogoForm from '../logo_form/SetLogoForm';
import DashboardCard from '../dashboardComponents/DashboardCard';
import SetAdvForm from '../advertisments_form/SetAdvForm';
import SubscriptionForm from '../unsubscription_form/SubscriptionForm';

export default function DashboardEdit({website, currentCard, setCurrentCard}) {
  const [businessFlag,setBusinessFlag] = useState(false);
  const [personalFlag,setPersonalFlag] = useState(false);
  const [logoFlag,setLogoFlag] = useState(false);
  const [advFlag,setAdvFlag] = useState(false);
  const [socialFlag,setSocialFlag] = useState(false);
  const [themeFlag,setThemeFlag] = useState(false);
  const [navFlag,setNavFlag] = useState(false);
  const [subscriptionFlag, setSubscriptionFlag] = useState(false);

  const [unsubscribeFlag, setUnsubscribeFlag] = useState(false);

  // Cards opening effect
  useEffect(()=>{
    if(currentCard === "dashboardCard_business"){
      setBusinessFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_personal"){
      setPersonalFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_logo"){
      setLogoFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_adv"){
      setAdvFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_social"){
      setSocialFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_theme"){
      setThemeFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_nav"){
      setNavFlag(true);
      return;
    }
    if(currentCard === "dashboardCard_subscription"){
      setSubscriptionFlag(true);
      return;
    }
  },[currentCard])
  return (
    <div>
      <DashboardCard _id={"dashboardCard_business"} text={"פרטים על האתר - כללי"} action={()=>{setBusinessFlag(!businessFlag);setPersonalFlag(false);setLogoFlag(false);setAdvFlag(false);setSocialFlag(false);setThemeFlag(false);setNavFlag(false); setSubscriptionFlag(false)}} flag={businessFlag} setCurrentCard={setCurrentCard} child={<SetBusinessInfoForm website={website}/>}/>

      <DashboardCard _id={"dashboardCard_personal"} text={"פרטי התחברות אישיים"} action={()=>{setBusinessFlag(false);setPersonalFlag(!personalFlag);setLogoFlag(false);setAdvFlag(false);setSocialFlag(false);setThemeFlag(false);setNavFlag(false); setSubscriptionFlag(false)}} flag={personalFlag} setCurrentCard={setCurrentCard} child={<SetPersonalInfoForm website={website}/>}/>

      <DashboardCard _id={"dashboardCard_logo"} text={"עדכון לוגו"} action={()=>{setBusinessFlag(false);setPersonalFlag(false);setLogoFlag(!logoFlag);setAdvFlag(false);setSocialFlag(false);setThemeFlag(false);setNavFlag(false); setSubscriptionFlag(false)}} flag={logoFlag} setCurrentCard={setCurrentCard} child={<SetLogoForm website={website}/>}/>

      <DashboardCard _id={"dashboardCard_adv"} text={"תמונות ספינר (פרסומות)"} action={()=>{setBusinessFlag(false);setPersonalFlag(false);setLogoFlag(false);setAdvFlag(!advFlag);setSocialFlag(false);setThemeFlag(false);setNavFlag(false); setSubscriptionFlag(false)}} flag={advFlag} setCurrentCard={setCurrentCard} child={<SetAdvForm website={website}/>}/>

      <DashboardCard _id={"dashboardCard_social"} text={"רשתות חברתיות"} action={()=>{setBusinessFlag(false);setPersonalFlag(false);setLogoFlag(false);setAdvFlag(false);setSocialFlag(!socialFlag);setThemeFlag(false);setNavFlag(false); setSubscriptionFlag(false)}} flag={socialFlag} setCurrentCard={setCurrentCard} child={<SetSocialForm website={website}/>}/>

      <DashboardCard _id={"dashboardCard_theme"} text={"שינוי צבעי נושא"} action={()=>{setBusinessFlag(false);setPersonalFlag(false);setLogoFlag(false);setAdvFlag(false);setSocialFlag(false);setThemeFlag(!themeFlag);setNavFlag(false); setSubscriptionFlag(false)}} flag={themeFlag} setCurrentCard={setCurrentCard} child={<SetThemeForm website={website}/>}/>

      <DashboardCard _id={"dashboardCard_nav"} text={"הגדרות כפתורי ניווט"} action={()=>{setBusinessFlag(false);setPersonalFlag(false);setLogoFlag(false);setAdvFlag(false);setSocialFlag(false);setThemeFlag(false);setNavFlag(!navFlag); setSubscriptionFlag(false)}} flag={navFlag} setCurrentCard={setCurrentCard} child={<SetNavbarForm website={website}/>}/>
      
      <DashboardCard _id={"dashboardCard_subscription"} text={"מחיקת מנוי והפסקת שירות"} action={()=>{setBusinessFlag(false);setPersonalFlag(false);setLogoFlag(false);setAdvFlag(false);setSocialFlag(false);setThemeFlag(false);setNavFlag(false); setSubscriptionFlag(!subscriptionFlag)}} flag={subscriptionFlag} setCurrentCard={setCurrentCard} child={<SubscriptionForm website={website}/>}/>
    </div>
  )
}
